import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';

//import { LoginService } from '../../account/auth/service/login.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  browserName:any
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
      private authFackservice: AuthfakeauthenticationService,
      private oauthService: OAuthService,
    ) { this.getBrowserName() }
  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      //case agent.indexOf('firefox') > -1:
      //  return 'firefox';
      //case agent.indexOf('safari') > -1:
      //  return 'safari';
      default:
        return 'other';
    }
  }
   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise <boolean > {
     debugger
     return new Promise((resolve) => {
       setTimeout(() => {
       const currentUser = null //this.loginService.currentUserValue
       // not logged in so redirect to login page with the return url
       if (this.oauthService.hasValidAccessToken()) {
         if (!currentUser && !(state.url.includes('login') || (state.url.includes('/')))) {
           debugger
           this.router.navigate(['/login']);
           resolve(false)
         }
         resolve(true);
       }
       else {
         this.oauthService.initCodeFlow();
         resolve(false)
         }
       }, this.browserName=='other'?1000:600)
     })

    //if (state.url.includes('login')) {
    //  this.router.navigate(['/login']);
    //  return false
    //}
    //else {
    //  this.oauthService.initCodeFlow();
    //  return false;
    //}
  }
}
